module.exports = __webpack_public_path__ + "img/level_8.285bcb8c.svg";